import { render, staticRenderFns } from "./SLPView.vue?vue&type=template&id=51490c34&scoped=true&"
import script from "./SLPView.vue?vue&type=script&lang=ts&"
export * from "./SLPView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51490c34",
  null
  
)

export default component.exports